export default "\r\n    <app-header></app-header>\r\n\r\n\r\n  <app-donor></app-donor>\r\n  <app-router></app-router>\r\n\r\n"